import { SET_RX_FORM_VALUES } from '../actions/userInformation/types';

const initState = {};

const lookup = (state = initState, action) => {
  switch (action.type) {
    case SET_RX_FORM_VALUES:
      return {
        RxLookupForm: action.payload,
      };

    default:
      return state;
  }
};

export default lookup;



// WEBPACK FOOTER //
// ./src/reducers/lookup.js